import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-backspace" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Logi sisse", -1)
const _hoisted_3 = { className: "row" }
const _hoisted_4 = { className: "col-sm" }
const _hoisted_5 = {
  key: 0,
  className: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "e-mail", -1)
const _hoisted_8 = { className: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "lastname"
}, "parool", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_GoogleSignInButton = _resolveComponent("GoogleSignInButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, { to: { name: 'home' } }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            className: "form-control",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            className: "form-control",
            type: "password"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loginClicked && _ctx.loginClicked(...args))),
              class: "btn btn-primary w-100"
            }, " Logi sisse ")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_GoogleSignInButton, {
              onSuccess: _ctx.handleLoginSuccess,
              onError: _ctx.handleLoginError,
              class: "w-100"
            }, null, 8, ["onSuccess", "onError"])
          ])
        ])
      ])
    ])
  ], 64))
}